export default __webpack_public_path__ + "static/media/thumb-IVTS-4.ece420a0.png";